// routes/LoginRoutes.jsx
import { lazy } from 'react';
import Loadable from '../Components/Loadable.js';
const Login = Loadable(lazy(() => import('../pages/Login/Login.jsx')));

const LoginRoutes = {
  path: '/',
  children: [
    { path: 'login', element: <Login /> },
    { path: '', element: <Login /> }
  ]
};

export default LoginRoutes;
